<script>
  export let assetsPath = './';
  let width = null;
  import { onMount } from 'svelte';
  export let onAiMounted = () => {};
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-rihanna-text-intro-box" bind:clientWidth={width}>
  <!-- Artboard: xs -->
  {#if width && width >= 0 && width < 660}
    <div id="g-rihanna-text-intro-xs-330" class="g-artboard" style="">
      <div style="padding: 0 0 596.9697% 0;"></div>
      <div
        id="g-rihanna-text-intro-xs-330-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/rihanna-text-intro-xs-330.png);"
      ></div>
      <div
        id="g-ai0-1"
        class="g-lil-years_copy_3 g-aiAbs g-aiPointText"
        style="top:3.205%;margin-top:-18.1px;left:19.9251%;width:64px;"
      >
        <p class="g-pstyle0">&lsquo;07</p>
      </div>
      <div
        id="g-ai0-2"
        class="g-lil-years_copy_3 g-aiAbs g-aiPointText"
        style="top:10.7685%;margin-top:-18.1px;left:35.3797%;width:56px;"
      >
        <p class="g-pstyle0">&lsquo;11</p>
      </div>
      <div
        id="g-ai0-3"
        class="g-lil-years_copy_3 g-aiAbs g-aiPointText"
        style="top:12.3928%;margin-top:-18.1px;left:61.2857%;width:59px;"
      >
        <p class="g-pstyle0">&lsquo;12</p>
      </div>
      <div
        id="g-ai0-4"
        class="g-lil-years_copy_3 g-aiAbs g-aiPointText"
        style="top:21.6822%;margin-top:-18.1px;left:68.9839%;width:59px;"
      >
        <p class="g-pstyle0">&lsquo;14</p>
      </div>
      <div
        id="g-ai0-5"
        class="g-lil-years_copy_3 g-aiAbs g-aiPointText"
        style="top:33.9157%;margin-top:-18.1px;left:69.3272%;width:59px;"
      >
        <p class="g-pstyle0">&lsquo;15</p>
      </div>
      <div
        id="g-ai0-6"
        class="g-lil-years_copy_3 g-aiAbs g-aiPointText"
        style="top:58.0781%;margin-top:-18.1px;left:20.5148%;width:56px;"
      >
        <p class="g-pstyle0">&lsquo;17</p>
      </div>
      <div
        id="g-ai0-7"
        class="g-lil-years_copy_3 g-aiAbs g-aiPointText"
        style="top:59.2456%;margin-top:-18.1px;left:66.6283%;width:59px;"
      >
        <p class="g-pstyle0">&lsquo;18</p>
      </div>
      <div
        id="g-ai0-8"
        class="g-lil-years_copy_3 g-aiAbs g-aiPointText"
        style="top:74.1187%;margin-top:-18.1px;left:8.6947%;width:59px;"
      >
        <p class="g-pstyle0">&lsquo;21</p>
      </div>
      <div
        id="g-ai0-9"
        class="g-lil-years_copy_3 g-aiAbs g-aiPointText"
        style="top:87.8243%;margin-top:-18.1px;left:36.7917%;width:62px;"
      >
        <p class="g-pstyle0">&lsquo;23</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: md -->
  {#if width && width >= 660 && width < 930}
    <div id="g-rihanna-text-intro-md-660" class="g-artboard" style="">
      <div style="padding: 0 0 430.303% 0;"></div>
      <div
        id="g-rihanna-text-intro-md-660-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/rihanna-text-intro-md-660.png);"
      ></div>
      <div
        id="g-ai1-1"
        class="g-lil-years_copy_2 g-aiAbs g-aiPointText"
        style="top:8.941%;margin-top:-13.9px;left:30.0687%;width:48px;"
      >
        <p class="g-pstyle0">&lsquo;11</p>
      </div>
      <div
        id="g-ai1-2"
        class="g-lil-years_copy_2 g-aiAbs g-aiPointText"
        style="top:12.11%;margin-top:-13.9px;left:45.1511%;width:50px;"
      >
        <p class="g-pstyle0">&lsquo;12</p>
      </div>
      <div
        id="g-ai1-3"
        class="g-lil-years_copy_2 g-aiAbs g-aiPointText"
        style="top:27.603%;margin-top:-13.9px;left:79.6169%;width:50px;"
      >
        <p class="g-pstyle0">&lsquo;15</p>
      </div>
      <div
        id="g-ai1-4"
        class="g-lil-years_copy_2 g-aiAbs g-aiPointText"
        style="top:47.9239%;margin-top:-15px;left:29.5295%;width:51px;"
      >
        <p class="g-pstyle1">&lsquo;17</p>
      </div>
      <div
        id="g-ai1-5"
        class="g-lil-years_copy_2 g-aiAbs g-aiPointText"
        style="top:51.5466%;margin-top:-13.9px;left:90.857%;width:50px;"
      >
        <p class="g-pstyle0">&lsquo;18</p>
      </div>
      <div
        id="g-ai1-6"
        class="g-lil-years_copy_2 g-aiAbs g-aiPointText"
        style="top:65.5255%;margin-top:-13.9px;left:6.9111%;width:50px;"
      >
        <p class="g-pstyle0">&lsquo;21</p>
      </div>
      <div
        id="g-ai1-7"
        class="g-lil-years_copy_2 g-aiAbs g-aiPointText"
        style="top:84.1899%;margin-top:-10px;left:37.9337%;width:44px;"
      >
        <p class="g-pstyle2">&lsquo;23</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: lg -->
  {#if width && width >= 930 && width < 1200}
    <div id="g-rihanna-text-intro-lg-930" class="g-artboard" style="">
      <div style="padding: 0 0 309.6774% 0;"></div>
      <div
        id="g-rihanna-text-intro-lg-930-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/rihanna-text-intro-lg-930.png);"
      ></div>
      <div
        id="g-ai2-1"
        class="g-lil-years_copy g-aiAbs g-aiPointText"
        style="top:9.4765%;margin-top:-13.9px;left:29.4036%;width:48px;"
      >
        <p class="g-pstyle0">&lsquo;11</p>
      </div>
      <div
        id="g-ai2-2"
        class="g-lil-years_copy g-aiAbs g-aiPointText"
        style="top:12.046%;margin-top:-13.9px;left:40.9674%;width:50px;"
      >
        <p class="g-pstyle0">&lsquo;12</p>
      </div>
      <div
        id="g-ai2-3"
        class="g-lil-years_copy g-aiAbs g-aiPointText"
        style="top:23.5043%;margin-top:-13.9px;left:67.6268%;width:50px;"
      >
        <p class="g-pstyle0">&lsquo;15</p>
      </div>
      <div
        id="g-ai2-4"
        class="g-lil-years_copy g-aiAbs g-aiPointText"
        style="top:42.675%;margin-top:-15px;left:36.2323%;width:51px;"
      >
        <p class="g-pstyle1">&lsquo;17</p>
      </div>
      <div
        id="g-ai2-5"
        class="g-lil-years_copy g-aiAbs g-aiPointText"
        style="top:46.8724%;margin-top:-13.9px;left:88.0491%;width:50px;"
      >
        <p class="g-pstyle0">&lsquo;18</p>
      </div>
      <div
        id="g-ai2-6"
        class="g-lil-years_copy g-aiAbs g-aiPointText"
        style="top:60.171%;margin-top:-13.9px;left:6.195%;width:50px;"
      >
        <p class="g-pstyle0">&lsquo;21</p>
      </div>
      <div
        id="g-ai2-7"
        class="g-lil-years_copy g-aiAbs g-aiPointText"
        style="top:82.289%;margin-top:-13.9px;left:33.6311%;width:52px;"
      >
        <p class="g-pstyle0">&lsquo;23</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: xs -->
  {#if width && width >= 1200}
    <div id="g-rihanna-text-intro-xs-1200" class="g-artboard" style="">
      <div style="padding: 0 0 240% 0;"></div>
      <div
        id="g-rihanna-text-intro-xs-1200-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/rihanna-text-intro-xs-1200.png);"
      ></div>
      <div
        id="g-ai3-1"
        class="g-lil-years g-aiAbs g-aiPointText"
        style="top:8.925%;margin-top:-15px;left:35.4677%;width:50px;"
      >
        <p class="g-pstyle0">&lsquo;11</p>
      </div>
      <div
        id="g-ai3-2"
        class="g-lil-years g-aiAbs g-aiPointText"
        style="top:10.9041%;margin-top:-15px;left:45.2674%;width:53px;"
      >
        <p class="g-pstyle0">&lsquo;12</p>
      </div>
      <div
        id="g-ai3-3"
        class="g-lil-years g-aiAbs g-aiPointText"
        style="top:21.3208%;margin-top:-15px;left:67.8596%;width:53px;"
      >
        <p class="g-pstyle0">&lsquo;15</p>
      </div>
      <div
        id="g-ai3-4"
        class="g-lil-years g-aiAbs g-aiPointText"
        style="top:40.7652%;margin-top:-15px;left:28.33%;width:51px;"
      >
        <p class="g-pstyle0">&lsquo;17</p>
      </div>
      <div
        id="g-ai3-5"
        class="g-lil-years g-aiAbs g-aiPointText"
        style="top:45.5222%;margin-top:-15px;left:72.7736%;width:53px;"
      >
        <p class="g-pstyle0">&lsquo;18</p>
      </div>
      <div
        id="g-ai3-6"
        class="g-lil-years g-aiAbs g-aiPointText"
        style="top:56.668%;margin-top:-15px;left:7.2499%;width:53px;"
      >
        <p class="g-pstyle0">&lsquo;21</p>
      </div>
      <div
        id="g-ai3-7"
        class="g-lil-years g-aiAbs g-aiPointText"
        style="top:81.3208%;margin-top:-15px;left:38.1554%;width:55px;"
      >
        <p class="g-pstyle0">&lsquo;23</p>
      </div>
    </div>
  {/if}
</div>
<!-- End ai2html - 2025-05-02 14:49 -->

<!-- Generated by ai2html v0.100.0 - 2025-05-02 14:49 -->
<!-- ai file: rihanna-text-intro.ai -->
<style lang="scss">
  #g-rihanna-text-intro-box,
  #g-rihanna-text-intro-box .g-artboard {
    margin: 0 auto;
  }
  #g-rihanna-text-intro-box p {
    margin: 0;
  }
  #g-rihanna-text-intro-box .g-aiAbs {
    position: absolute;
  }
  #g-rihanna-text-intro-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-rihanna-text-intro-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-rihanna-text-intro-xs-330 {
    position: relative;
    overflow: hidden;
  }
  #g-rihanna-text-intro-xs-330 p {
    font-family: LibreBodoni-Regular;
    font-weight: 700;
    line-height: 31px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 26px;
    text-align: left;
    color: rgb(218, 218, 218);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-rihanna-text-intro-xs-330 .g-pstyle0 {
    height: 31px;
  }
  #g-rihanna-text-intro-md-660 {
    position: relative;
    overflow: hidden;
  }
  #g-rihanna-text-intro-md-660 p {
    font-family: LibreBodoni-Regular;
    font-weight: 700;
    line-height: 24px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 20px;
    text-align: left;
    color: rgb(218, 218, 218);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-rihanna-text-intro-md-660 .g-pstyle0 {
    height: 24px;
  }
  #g-rihanna-text-intro-md-660 .g-pstyle1 {
    line-height: 26px;
    height: 26px;
    font-size: 22px;
  }
  #g-rihanna-text-intro-md-660 .g-pstyle2 {
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-rihanna-text-intro-lg-930 {
    position: relative;
    overflow: hidden;
  }
  #g-rihanna-text-intro-lg-930 p {
    font-family: LibreBodoni-Regular;
    font-weight: 700;
    line-height: 24px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 20px;
    text-align: left;
    color: rgb(218, 218, 218);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-rihanna-text-intro-lg-930 .g-pstyle0 {
    height: 24px;
  }
  #g-rihanna-text-intro-lg-930 .g-pstyle1 {
    line-height: 26px;
    height: 26px;
    font-size: 22px;
  }
  #g-rihanna-text-intro-xs-1200 {
    position: relative;
    overflow: hidden;
  }
  #g-rihanna-text-intro-xs-1200 p {
    font-family: LibreBodoni-Regular;
    font-weight: 700;
    line-height: 26px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 22px;
    text-align: left;
    color: rgb(218, 218, 218);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-rihanna-text-intro-xs-1200 .g-pstyle0 {
    height: 26px;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
